module.exports = __webpack_public_path__ + "static/media/future.c67cd2ca.svg";